function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext, useEffect, useState } from "react";
import { ComboBox, SelectSkeleton } from "@carbon/react";
import { idContext, i18nContext } from "../../table-context";
import api from "./AppConfigApi";
import { APP_CONFIG_FEATURE, APP_CONFIG_OPTION_PROP } from "../../Constants";
var itemToString = function itemToString(item) {
  return item ? item.text : "";
};
function ConfigureFeatureSelect(_ref) {
  var collectionProperty = _ref.collectionProperty,
    environmentProperty = _ref.environmentProperty,
    featureProperty = _ref.featureProperty,
    findSelectedItem = _ref.findSelectedItem,
    integrationProperty = _ref.integrationProperty,
    optionsProperty = _ref.optionsProperty,
    updateAppConfigProperty = _ref.updateAppConfigProperty;
  var i18n = useContext(i18nContext);
  var id = useContext(idContext);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItem = _useState4[0],
    setSelectedItem = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  function fetchData() {
    if (!integrationProperty || !integrationProperty.value || !optionsProperty || !optionsProperty.value || optionsProperty.value === APP_CONFIG_OPTION_PROP) {
      setItems([]);
    } else {
      setIsLoading(true);
      var serviceId = integrationProperty.value;
      api.getAppConfigFeatures({
        collectionId: collectionProperty.value,
        environmentId: environmentProperty.value,
        envId: id.envId,
        serviceId: serviceId,
        toolchainId: id.toolchainId
      }).then(function (result) {
        var feature_list = result.body;
        var features = feature_list.features ? feature_list.features.map(function (listFeatures) {
          return {
            id: listFeatures.feature_id,
            text: listFeatures.name
          };
        }).sort(function (a, b) {
          return a.text.localeCompare(b.text);
        }) : [];
        setItems(features);
        if ((features === null || features === void 0 ? void 0 : features.length) === 1) {
          updateAppConfigProperty(APP_CONFIG_FEATURE, features[0].id);
        }
      })["finally"](function () {
        setIsLoading(false);
      });
    }
  }
  useEffect(function () {
    fetchData();
  }, [integrationProperty, optionsProperty, environmentProperty, collectionProperty]);
  useEffect(function () {
    if (items && featureProperty && featureProperty.value) {
      var item = findSelectedItem(featureProperty, items);
      setSelectedItem(item);
    }
  }, [items, featureProperty]);
  var handleChange = function handleChange(event) {
    var _event$selectedItem;
    var value = ((_event$selectedItem = event.selectedItem) === null || _event$selectedItem === void 0 ? void 0 : _event$selectedItem.id) || "";
    updateAppConfigProperty(APP_CONFIG_FEATURE, value);
  };
  var translateIds = function translateIds(menuId) {
    var translations = {
      "close.menu": i18n.messages.menuClose,
      "open.menu": i18n.messages.menuOpen
    };
    return translations[menuId];
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(SelectSkeleton, {
      className: "cds--form-item"
    });
  }
  if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
    return /*#__PURE__*/React.createElement(ComboBox, {
      className: "ocr--property-select-dropdown",
      direction: "bottom",
      id: "property-panel-appconfig-feature",
      items: items,
      itemToString: itemToString,
      onChange: handleChange,
      placeholder: i18n.messages.propertyAppConfigFeatureSelect,
      selectedItem: selectedItem,
      titleText: i18n.messages.propertyAppConfigFeatureLabel,
      translateWithId: translateIds
    });
  }
  return null;
}
export default ConfigureFeatureSelect;